function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useCallback, useMemo } from 'react';
import { Button, Form, FormControl } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { StateSelect } from '../../util';
import claimContractorsService from '../../services/claim/claim_contractors.service';
export function ContractorsRow(_ref) {
  let {
    showTypeAndYear = false,
    index,
    claim,
    handleDelete,
    claimContractors,
    setClaimContractors,
    refreshClaim,
    handleError
  } = _ref;
  const [hasError, setHasError] = useState(false);
  const claimContractor = useMemo(() => {
    return _objectSpread({}, claimContractors[index]);
  }, [claimContractors, index]);
  const dispatch = useDispatch();
  const updateContractors = useCallback(subcontractor => {
    const newContractors = [...claimContractors];
    newContractors[index] = _objectSpread({}, subcontractor);
    setClaimContractors([...newContractors]);
  }, [claimContractors, index, setClaimContractors]);
  const handleChange = useCallback(event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    claimContractor[event.target.name] = value;
    updateContractors(claimContractor);
  }, [updateContractors, claimContractor]);
  const saveChange = useCallback(() => {
    let method;
    if (claimContractor.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimContractorsService[method](claimContractor).then(updatedSubcontractor => {
      setHasError(false);
      updateContractors(updatedSubcontractor);
      refreshClaim();
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [updateContractors, claimContractor, dispatch, refreshClaim]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: Form.Control,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked,
    name: "name",
    object: _objectSpread(_objectSpread({}, claimContractor), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimContractor.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: "textarea",
    onChange: handleChange,
    onBlur: saveChange,
    name: "services_provided",
    object: _objectSpread(_objectSpread({}, claimContractor), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimContractor.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: StateSelect,
    state: claimContractor.state,
    onChange: e => {
      handleChange(e);
      saveChange();
    },
    disabled: claim.financials_locked,
    name: "state",
    object: _objectSpread(_objectSpread({}, claimContractor), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimContractor.claim)
    }),
    size: "sm",
    type: "text"
  })), showTypeAndYear && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormControl, {
    disabled: true,
    name: "type",
    type: "text",
    size: "sm",
    value: claimContractor.claim.id_in_provider_system ? 'Claim' : 'Base'
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormControl, {
    disabled: true,
    name: "type",
    type: "text",
    size: "sm",
    value: claimContractor.claim.label
  }))), /*#__PURE__*/React.createElement("td", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked,
    name: "expense",
    object: _objectSpread(_objectSpread({}, claimContractor), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimContractor.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    onChange: handleChange,
    onBlur: saveChange,
    disabled: claim.financials_locked,
    name: "rnd_apportionment",
    object: _objectSpread(_objectSpread({}, claimContractor), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimContractor.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    disabled: true,
    name: "qre",
    object: _objectSpread(_objectSpread({}, claimContractor), {}, {
      claim: _objectSpread(_objectSpread({}, claim), claimContractor.claim)
    }),
    size: "sm",
    type: "text"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    variant: "secondary",
    disabled: claim.is_locked || claim.financials_locked || claim.active_change_set,
    style: {
      height: '28px'
    },
    onClick: handleDelete
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons text-danger"
  }, "delete")))));
}